<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 style="color:white;">Complaint Response Letter</h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="flex flex-col w-full">
      <br />
      <div class="flex flex-row w-full">

        <div>
          <button mat-raised-button (click)="copyToClipBoard()"> Copy Text to Clipboard </button>
        </div>
        <div style="padding-left: 20px;">
          <button mat-raised-button (click)="return()" style="padding-right: 20px;">
            Return
          </button>
        </div>
      </div>
      <br /><br />

      <kendo-editor [readonly]=true [(value)]="letterBody" style="height: 600px;width: 780px;"></kendo-editor>

      <!-- <div id="letterText" [innerHTML]="correspondenceModalLetterText"></div> -->

      <br /><br />
      <br />
      <div style="padding-right: 20px;">
        <button mat-raised-button (click)="return()" style="padding-right: 20px;">
          Return
        </button>
      </div>
    </div>
  </mat-card-content>

</mat-card>